module.exports = __webpack_public_path__ + "img/bgIcon_3.edaa0e04.png";